import { useState } from 'react';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';

function CreaItem({ onClose, onItemCreated }) {

	const { sapDB, mail } = useSelector((state) => state.user);
	const [isLoading, setIsLoading] = useState(false);

	const [ItemCode, setItemCode] = useState('');
	const [errors, setErrors] = useState({ code: false });

	const [ItemName, setItemName] = useState('');
	const [ItemType, setItemType] = useState('itItems');
	const [ItemsGroupCode, setItemsGroupCode] = useState('');

	const [PurchaseItem, setPurchaseItem] = useState('tYES');
	const [SalesItem, setSalesItem] = useState('tNO');
	const [InventoryItem, setInventoryItem] = useState('tYES');

	const [PurchaseUnit, setPurchaseUnit] = useState('');
	const [SalesUnit, setSalesUnit] = useState('');
	const [InventoryUOM, setInventoryUOM] = useState('');

	const [Valid, setValid] = useState('tNO');
	const [Frozen, setFrozen] = useState('tNO');

	const [VatLiable, setVatLiable] = useState('tNO');
	const [TaxType, setTaxType] = useState('tt_No');

	const [grp, setGrp] = useState([]);
	//const [data, setData] = useState([]);
	const data = []

	const handleCreateItem = async () => {

		setIsLoading(true);
		const newErrors = {};

		const payload = {
			ItemCode,
			ItemName,
			ItemType,
			ItemsGroupCode,
			PurchaseItem,
			SalesItem,
			InventoryItem,
			PurchaseUnit,
			SalesUnit,
			InventoryUOM,
			Valid,
			Frozen,
			VatLiable,
			TaxType,
		};

		if (ItemCode === '') newErrors.code = true;
		if (ItemName === '') newErrors.name = true;

		setErrors(newErrors);
		if (Object.values(newErrors).some(error => error)) {
			setIsLoading(false);
			return;
		}

		const codeExists = await existCodeInSAP();

		if (codeExists) {
			alert(`El código ${ItemCode} ya existe en SAP.`);
			setIsLoading(false);
			return
		} else {

			try {
				const resp = await fetch(apiurl + 'createCodeInSap', {
					method: 'POST',
					credentials: 'include',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ ...payload, user: mail }),
				});

				if (resp.ok) {
					const resData = await resp.json();
					const msgs = Array.isArray(resData.msg) ? resData.msg.join('\n') : resData.msg;
					alert(msgs);

					// Crear objeto con los datos del nuevo item
					const newItem = {
						code: ItemCode,
						name: ItemName,
						grou: grp.find(g => g.numb === ItemsGroupCode)?.grou || '',
						hand: 0,
						orde: 0,
						comm: 0,
						soli: 0,
						cost: 0
					};

					// Llamar a la función callback para agregar el item
					if (onItemCreated) {
						onItemCreated(newItem);
					}

					onClose();
				} else {
					alert('Error al crear el artículo');
					console.error('Error al crear el artículo');
				}
				setIsLoading(false);

			} catch (error) {
				alert('Error al crear el artículo');
				console.error('Error en la solicitud:', error);
				setIsLoading(false);
			}
		}

	};

	const existCodeInSAP = async () => {
		const payload = { ItemCode, sapDB, user: mail };

		try {
			const response = await fetch(apiurl + 'existCodeInSAP', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(payload),
			});

			if (!response.ok) {
				throw new Error('Error al verificar el código');
			}

			const result = await response.json()
			console.log(result.exists);
			return result.exists;
		} catch (error) {
			console.error('Error al verificar el código:', error);
			setIsLoading(false);
			return false;
		}
	};

	const loadGrp = async () => {
		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'include',
				body: JSON.stringify({ user: mail, query: `SELECT numb, grou FROM inv__grou ORDER BY grou ASC` }),
			});

			if (response.ok) {
				const data = await response.json();
				setGrp(data);
				if (data.length > 0) {
					setItemsGroupCode(data[0].numb);
				}
			} else {
				console.error('Error al obtener los grupos');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	}

	useState(() => {
		loadGrp();
	}, []);
	return (
		<form>
			<orm-modal>
				<dialog open>
					<h2>Creando artículo</h2>

					<fieldset>
						<legend>Identificación</legend>
						<table>
							<tbody>
								<tr>
									<td>Código:</td>
									<td><input type="text" value={ItemCode} onChange={e => setItemCode(e.target.value)} className={errors.code || data[0]?.code === 1 ? 'error' : ''} /></td>
								</tr>
								<tr>
									<td>Nombre:</td>
									<td><input type="text" value={ItemName} onChange={e => setItemName(e.target.value)} className={errors.code || data[0]?.code === 1 ? 'error' : ''}/></td>
								</tr>
								<tr>
									<td>Clase:</td>
									<td>
										<select value={ItemType} onChange={e => setItemType(e.target.value)}>
											<option value="itItems">Artículo</option>
											<option value="itFixedAssets">Activo fijo</option>
										</select>
									</td>
								</tr>
								<tr>
									<td>Grupo:</td>
									<td>
										<select value={ItemsGroupCode} onChange={e => setItemsGroupCode(e.target.value)}>
											{grp.map((g, index) => (
												<option key={index} value={g.numb}>{g.grou}</option>
											))}
										</select>
									</td>
								</tr>
							</tbody>
						</table>
					</fieldset>

					<fieldset>
						<legend>Logística</legend>
						<table>
							<tbody>
								<tr>
									<td>
										<label><input type="checkbox" checked={PurchaseItem === 'tYES' ? true : false} style={{ width: 'initial' }} onChange={e => setPurchaseItem(e.target.checked ? 'tYES' : 'tNO')} /> Compra:</label>
									</td>
									<td>
										<input type="text" placeholder="Unidad de medida" value={PurchaseUnit} onChange={e => setPurchaseUnit(e.target.value)} disabled={!PurchaseItem} />
									</td>
								</tr>
								<tr>
									<td>
										<label><input type="checkbox" checked={SalesItem === 'tYES' ? true : false} style={{ width: 'initial' }} onChange={e => setSalesItem(e.target.checked ? 'tYES' : 'tNO')} /> Venta:</label>
									</td>
									<td>
										<input type="text" placeholder="Unidad de venta" value={SalesUnit} onChange={e => setSalesUnit(e.target.value)} disabled={!SalesItem} />
									</td>
								</tr>
								<tr>
									<td>
										<label><input type="checkbox" checked={InventoryItem === 'tYES' ? true : false} style={{ width: 'initial' }} onChange={e => setInventoryItem(e.target.checked ? 'tYES' : 'tNO')} /> Inventario:</label>
									</td>
									<td>
										<input type="text" placeholder="Unidad inventario" value={InventoryUOM} onChange={e => setInventoryUOM(e.target.value)} disabled={!InventoryItem} />
									</td>
								</tr>
							</tbody>
						</table>
					</fieldset>

					<fieldset>
						<legend>Estado</legend>
						<table>
							<tbody>
								<tr>
									<td><label><input type="checkbox" checked={Valid === 'tYES'} style={{ width: 'initial' }} onChange={e => setValid(e.target.checked ? 'tYES' : 'tNO')} /> Válido</label></td>
									<td><label><input type="checkbox" checked={Frozen === 'tYES'} style={{ width: 'initial' }} onChange={e => setFrozen(e.target.checked ? 'tYES' : 'tNO')} /> Inactivo</label></td>
								</tr>
							</tbody>
						</table>
					</fieldset>

					<fieldset>
						<legend>Impuesto</legend>
						<table>
							<tbody>
								<tr>
									<td><label><input type="checkbox" checked={VatLiable === 'tYES'} style={{ width: 'initial' }} onChange={e => setVatLiable(e.target.checked ? 'tYES' : 'tNO')} /> Sujeto a IVA</label></td>
									<td><label><input type="checkbox" checked={TaxType === 'tt_Yes'} style={{ width: 'initial' }} onChange={e => setTaxType(e.target.checked ? 'tt_Yes' : 'tt_No')} /> Tiene impuesto</label></td>
								</tr>
							</tbody>
						</table>
					</fieldset>

					<table>
						<tfoot>
							<tr>
								<td></td>
								<td>
									<input type="button" value="Cancelar" onClick={onClose} />
									<input type="button" value={isLoading ? 'Cargando...' : 'Aceptar'} onClick={handleCreateItem} disabled={isLoading} />
								</td>
							</tr>
						</tfoot>
					</table>
				</dialog>
			</orm-modal>
		</form>
	);
}

export default CreaItem;